import { createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { class: "log-filters-compact" }
const _hoisted_2 = { class: "row g-1 align-items-end" }
const _hoisted_3 = { class: "col-lg col-md-4" }
const _hoisted_4 = { class: "col-lg col-md-4" }
const _hoisted_5 = { class: "col-lg col-md-4" }
const _hoisted_6 = ["value"]
const _hoisted_7 = ["value"]
const _hoisted_8 = { class: "col-lg col-md-4" }
const _hoisted_9 = ["value"]
const _hoisted_10 = ["value"]
const _hoisted_11 = { class: "col-lg col-md-4" }
const _hoisted_12 = ["value", "disabled"]
const _hoisted_13 = { value: "" }
const _hoisted_14 = ["label"]
const _hoisted_15 = ["value"]
const _hoisted_16 = { class: "col-lg col-md-4" }
const _hoisted_17 = ["value"]
const _hoisted_18 = { class: "col-lg-auto col-md-4" }
const _hoisted_19 = { class: "d-flex gap-1 align-items-end" }
const _hoisted_20 = ["disabled"]

import VueDatePicker from "@vuepic/vue-datepicker";
import { ref, computed } from "vue";
import { useQuery } from '@tanstack/vue-query';
import { fetchMasterData } from "../../../../api";
import { LOG_ACTIONS, LOG_BOOKING_KINDS } from "../../../../composables/useLogDisplay.js";


export default {
  __name: 'LogFilters',
  props: {
	table: {
		type: Object,
		required: true,
	},
	loading: {
		type: Boolean,
		default: false,
	},
	userApiUrl: {
		type: String,
		required: true,
	},
},
  emits: ["reset"],
  setup(__props, { emit: __emit }) {

const props = __props;

const emit = __emit;

// Use TanStack Query to fetch master data
const { data: masterData, isPending: roomsLoading } = useQuery({
	queryKey: ['master-data'],
	queryFn: ({ signal }) => {
		if (signal?.aborted) {
			throw new Error('Query was cancelled');
		}
		return fetchMasterData();
	},
	staleTime: 1000 * 60 * 10, // 10 minutes
	gcTime: 1000 * 60 * 60, // 1 hour
	retry: 3,
	retryDelay: (attemptIndex) => Math.min(1000 * 2 ** attemptIndex, 30000),
});

// Compute rooms by location from master data
const roomsByLocation = computed(() => {
	if (!masterData.value?.buildings?.list) return [];
	
	return Object.values(masterData.value.buildings.list).map(
		(location) => ({
			id: location.id,
			name: location.name,
			address: location.address,
			rooms: location.rooms || [],
		})
	);
});

const updateFilter = (id, value) => {
	if (!props.table) return;

	const currentFilters = props.table.getState().columnFilters;
	const newFilters = currentFilters.filter((f) => f.id !== id);

	if (value !== null && value !== "" && value !== undefined) {
		newFilters.push({ id, value });
	}

	props.table.setColumnFilters(newFilters);
};

const getFilterValue = (id) => {
	if (!props.table) return null;

	const filter = props.table.getState().columnFilters.find((f) => f.id === id);
	return filter ? filter.value : null;
};

const handleReset = () => {
	emit("reset");
};

return (_ctx, _cache) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createCommentVNode(" Date Range "),
      _createElementVNode("div", _hoisted_3, [
        _cache[6] || (_cache[6] = _createElementVNode("label", { class: "form-label-sm" }, "Von", -1 /* CACHED */)),
        _createVNode(_unref(VueDatePicker), {
          "model-value": getFilterValue('logFrom'),
          "enable-time-picker": false,
          format: "dd.MM.yyyy",
          clearable: true,
          placeholder: "Von",
          class: "form-control p-0 form-control-sm",
          "onUpdate:modelValue": _cache[0] || (_cache[0] = (value) => updateFilter('logFrom', value))
        }, null, 8 /* PROPS */, ["model-value"])
      ]),
      _createElementVNode("div", _hoisted_4, [
        _cache[7] || (_cache[7] = _createElementVNode("label", { class: "form-label-sm" }, "Bis", -1 /* CACHED */)),
        _createVNode(_unref(VueDatePicker), {
          "model-value": getFilterValue('logUntil'),
          "enable-time-picker": false,
          format: "dd.MM.yyyy",
          clearable: true,
          placeholder: "Bis",
          class: "form-control p-0 form-control-sm",
          "onUpdate:modelValue": _cache[1] || (_cache[1] = (value) => updateFilter('logUntil', value))
        }, null, 8 /* PROPS */, ["model-value"])
      ]),
      _createCommentVNode(" Action Filter "),
      _createElementVNode("div", _hoisted_5, [
        _cache[9] || (_cache[9] = _createElementVNode("label", { class: "form-label-sm" }, "Aktion", -1 /* CACHED */)),
        _createElementVNode("select", {
          value: getFilterValue('action') || '',
          class: "form-select form-select-sm",
          onChange: _cache[2] || (_cache[2] = (event) => updateFilter('action', event.target.value))
        }, [
          _cache[8] || (_cache[8] = _createElementVNode("option", { value: "" }, " Alle ", -1 /* CACHED */)),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(LOG_ACTIONS), (logAction) => {
            return (_openBlock(), _createElementBlock("option", {
              key: logAction.value,
              value: logAction.value
            }, _toDisplayString(logAction.label), 9 /* TEXT, PROPS */, _hoisted_7))
          }), 128 /* KEYED_FRAGMENT */))
        ], 40 /* PROPS, NEED_HYDRATION */, _hoisted_6)
      ]),
      _createCommentVNode(" Booking Kind Filter "),
      _createElementVNode("div", _hoisted_8, [
        _cache[11] || (_cache[11] = _createElementVNode("label", { class: "form-label-sm" }, "Buchungstyp", -1 /* CACHED */)),
        _createElementVNode("select", {
          value: getFilterValue('bookingKind') || '',
          class: "form-select form-select-sm",
          onChange: _cache[3] || (_cache[3] = (event) => updateFilter('bookingKind', event.target.value))
        }, [
          _cache[10] || (_cache[10] = _createElementVNode("option", { value: "" }, " Alle ", -1 /* CACHED */)),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(LOG_BOOKING_KINDS), (bookingKind) => {
            return (_openBlock(), _createElementBlock("option", {
              key: bookingKind.value,
              value: bookingKind.value
            }, _toDisplayString(bookingKind.label), 9 /* TEXT, PROPS */, _hoisted_10))
          }), 128 /* KEYED_FRAGMENT */))
        ], 40 /* PROPS, NEED_HYDRATION */, _hoisted_9)
      ]),
      _createCommentVNode(" Room Filter "),
      _createElementVNode("div", _hoisted_11, [
        _cache[12] || (_cache[12] = _createElementVNode("label", { class: "form-label-sm" }, "Raum", -1 /* CACHED */)),
        _createElementVNode("select", {
          value: getFilterValue('roomId') || '',
          class: "form-select form-select-sm",
          disabled: _unref(roomsLoading),
          onChange: _cache[4] || (_cache[4] = 
            (event) =>
              updateFilter(
                'roomId',
                event.target.value ? Number(event.target.value) : null
              )
          )
        }, [
          _createElementVNode("option", _hoisted_13, _toDisplayString(_unref(roomsLoading) ? "Lade Räume..." : "Alle Räume"), 1 /* TEXT */),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(roomsByLocation.value, (location) => {
            return (_openBlock(), _createElementBlock("optgroup", {
              key: location.id,
              label: `${location.name} - ${location.address}`
            }, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(location.rooms, (room) => {
                return (_openBlock(), _createElementBlock("option", {
                  key: room.id,
                  value: room.id
                }, _toDisplayString(room.doorLabel ? `${room.doorLabel} - ` : "") + _toDisplayString(room.name || `Raum ${room.number}`), 9 /* TEXT, PROPS */, _hoisted_15))
              }), 128 /* KEYED_FRAGMENT */))
            ], 8 /* PROPS */, _hoisted_14))
          }), 128 /* KEYED_FRAGMENT */))
        ], 40 /* PROPS, NEED_HYDRATION */, _hoisted_12)
      ]),
      _createCommentVNode(" User Search "),
      _createElementVNode("div", _hoisted_16, [
        _cache[13] || (_cache[13] = _createElementVNode("label", { class: "form-label-sm" }, "Benutzer", -1 /* CACHED */)),
        _createElementVNode("input", {
          value: getFilterValue('userName') || '',
          type: "text",
          class: "form-control form-control-sm",
          placeholder: "Benutzername",
          onInput: _cache[5] || (_cache[5] = (event) => updateFilter('userName', event.target.value))
        }, null, 40 /* PROPS, NEED_HYDRATION */, _hoisted_17)
      ]),
      _createCommentVNode(" Action Buttons "),
      _createElementVNode("div", _hoisted_18, [
        _createElementVNode("div", _hoisted_19, [
          _createElementVNode("button", {
            type: "button",
            class: "btn btn-outline-secondary btn-sm",
            disabled: __props.loading,
            onClick: handleReset
          }, " Reset ", 8 /* PROPS */, _hoisted_20)
        ])
      ])
    ])
  ]))
}
}

}